import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import {
  Edit as EditIcon,
  ExitToApp as ExitToAppIcon,
  ExpandMoreOutlined,
} from "@material-ui/icons";
import {
  ListItemIcon,
  List,
  ListItem,
  ListItemText,
  Popover,
  IconButton,
} from "@material-ui/core";
import translate from "i18n/translate";
import { authLogout } from "redux/auth/actions";
import { selectUserFullName } from "redux/auth/selectors";
import { ACCOUNT_LAYOUT_ROUTE } from "routes/account/accountPaths";
import roles from "constants/roles.constant";
import { useStyles } from "./headerStyles";
import { UserLetterAvatar } from "../../../utils";
import { SrButton } from "../../../common";

const UserMenu = ({ className, avatarImage, showUserName }) => {
  const classes = useStyles();
  const { user, role: userRole } = useSelector(({ auth }) => auth);
  const userFullName = useSelector(({ auth }) => selectUserFullName(auth));

  const [popOverOpen, setPopOverOpen] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClick = (event) => {
    setPopOverOpen(event.currentTarget);
  };

  const handleClose = () => {
    setPopOverOpen(null);
  };

  const userLogout = () => {
    dispatch(authLogout());
  };

  const navigateAccout = () => {
    history.push(ACCOUNT_LAYOUT_ROUTE);
  };

  const open = Boolean(popOverOpen);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className={className}>
      {showUserName ? (
        <SrButton
          className={classes.userInfoButton}
          size="small"
          aria-describedby={id}
          endIcon={<ExpandMoreOutlined />}
          startIcon={
            <UserLetterAvatar
              firstName={user?.first_name}
              lastName={user?.last_name}
              avatarImage={avatarImage}
            />
          }
          onClick={handleClick}
        >
          {userFullName}
        </SrButton>
      ) : (
        <IconButton className={classes.userInfoButton} onClick={handleClick}>
          <UserLetterAvatar
            firstName={user?.first_name}
            lastName={user?.last_name}
            avatarImage={avatarImage}
          />
        </IconButton>
      )}
      <Popover
        id={id}
        classes={{ paper: classes.userPopover }}
        open={open}
        anchorEl={popOverOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <List dense>
          {userRole === roles.OWNER && (
            <ListItem button onClick={navigateAccout}>
              <ListItemIcon>
                <EditIcon />
              </ListItemIcon>
              <ListItemText>{translate("header.settings")}</ListItemText>
            </ListItem>
          )}
          <ListItem button onClick={userLogout}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText>{translate("header.logout")}</ListItemText>
          </ListItem>
        </List>
      </Popover>
    </div>
  );
};

UserMenu.propTypes = {
  className: PropTypes.string,
  avatarImage: PropTypes.string,
  showUserName: PropTypes.bool,
};

UserMenu.defaultProps = {
  className: null,
  avatarImage: null,
  showUserName: true,
};

export default UserMenu;
